import React from 'react';

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "./card-title.module.scss";
import {CardTitle} from "./card-title";

export const CardTitleWrapper = observer(({children, controller, title, entity, className, ElementComponent, TitleTag}) => {
  const titleProps = {
    controller,
    ElementComponent,
    entity,
    TitleTag,
    title,
    shouldRenderSideElement: Boolean(ElementComponent)
  }

  return (
    <div className={classNames(className, styles.container)}>
      <CardTitle {...titleProps}/>
      {children}
    </div>
  );
});
